import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';

const AVATARS = ['😀', '😎', '🤓', '🥳', '🤠', '👻', '🦊', '🐱', '🦁', '🐸', '🦄', '🐲'];

function Join() {
  const { code: urlCode } = useParams();
  const navigate = useNavigate();
  
  const [joinCode, setJoinCode] = useState(urlCode || '');
  const [playerName, setPlayerName] = useState('');
  const [avatar, setAvatar] = useState('😀');
  const [step, setStep] = useState(urlCode ? 2 : 1);
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (urlCode) {
      checkSession(urlCode);
    }
  }, [urlCode]);

  const checkSession = async (code) => {
    setLoading(true);
    setError('');
    try {
      const response = await api.joinSession(code, 'temp', '😀');
      setSession(response.session);
      setStep(2);
    } catch (err) {
      setError(err.message || 'Quiz not found');
      setStep(1);
    } finally {
      setLoading(false);
    }
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (joinCode.length >= 4) {
      checkSession(joinCode);
    }
  };

  const handleJoin = async (e) => {
    e.preventDefault();
    if (!playerName.trim()) {
      setError('Please enter your name');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await api.joinSession(joinCode, playerName, avatar);
      localStorage.setItem('sessionToken', response.sessionToken);
      localStorage.setItem('participantId', response.participant.id);
      localStorage.setItem('playerName', response.participant.playerName);
      localStorage.setItem('playerAvatar', response.participant.avatarEmoji);
      navigate(`/play/${response.session.id}`);
    } catch (err) {
      setError(err.message || 'Failed to join');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="join-page">
      <div className="join-card">
        <h1>🎯 Join Quiz</h1>
        
        {step === 1 && (
          <>
            <p className="subtitle">Enter the quiz code to join</p>
            {error && <div className="error-message">{error}</div>}
            
            <form onSubmit={handleCodeSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  value={joinCode}
                  onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
                  placeholder="QUIZ-XXXX"
                  className="code-input"
                  maxLength={9}
                  required
                />
              </div>
              
              <button type="submit" className="btn btn-primary" disabled={loading || joinCode.length < 4}>
                {loading ? 'Checking...' : 'Find Quiz'}
              </button>
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <p className="subtitle">
              Joining: <strong>{session?.title || 'Quiz'}</strong>
            </p>
            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleJoin}>
              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  value={playerName}
                  onChange={(e) => setPlayerName(e.target.value)}
                  placeholder="Enter your name"
                  maxLength={30}
                  required
                />
              </div>

              <div className="form-group">
                <label>Choose Avatar</label>
                <div className="avatar-picker">
                  {AVATARS.map((emoji) => (
                    <button
                      key={emoji}
                      type="button"
                      className={`avatar-option ${avatar === emoji ? 'selected' : ''}`}
                      onClick={() => setAvatar(emoji)}
                    >
                      {emoji}
                    </button>
                  ))}
                </div>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Joining...' : 'Join Quiz!'}
              </button>
              
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => { setStep(1); setError(''); }}
              >
                ← Back
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default Join;
